import { createContext, ReactNode, useReducer } from 'react';

//Types
type State = {
  corretorId?: string;
  idWebsite: string;

  //Step One
  currentWebsiteColor: string;
  currentButtonsColor: string;
  websiteAddress: string;
  websiteTitle: string;
  selectedNameLogo: string;
  logoSulamerica: boolean;
  whatsappNumber: string;
  companyTitle: string;
  companySubtitle: string;
  selectedFileBanner: string;
  selectedFileBannerName: string;
  selectedFileLogo: string;
  selectedFileLogoName: string;
  ev: string;

  //Step Two
  cover: Array<any>;
  capital: string;
  capitalMin: string;
  capitalMax: string;
  assist: Array<any>;
  nameProduct: string;
  hasVariableCapital: boolean;
  descriptionProduct: string;
  idProduct: number;
  brokerage: string;
  agency: string;
  frequency: string;
  dataPublish: string;
  partner: boolean | null;
  registeredPartner: number | null;
  /** intermediação parceiro */
  percentage: string;

  //Step Three

  //Step Four
  selectedFileBannerFour: string;
  selectedFileBannerFourName: string;
  companyTitleFour: string;
  companySubtitleFour: string;
  profileFacebook: string;
  profileTwitter: string;
  profileInstagram: string;
  profileYoutube: string;
  profileLinkedin: string;
};

type Action = {
  type: StepsFormActions;
  payload: any;
};

type ContextType = {
  state: State;
  setState: (action: Action) => void;
};

type StepsFormProviderProps = {
  children: ReactNode;
};

const initialValues: State = {
  corretorId: '',
  idWebsite: location.pathname.split('/')[4],

  //Step One
  currentWebsiteColor: '#FF5000',
  currentButtonsColor: '#FFFFFF',
  websiteAddress: '',
  websiteTitle: '',
  logoSulamerica: true,
  selectedNameLogo: '',
  whatsappNumber: '',
  companyTitle: '',
  companySubtitle: '',
  selectedFileBanner: '',
  selectedFileBannerName: '',
  selectedFileLogo: '',
  nameProduct: '',
  selectedFileLogoName: '',
  ev: '',

  //Step Two
  cover: [
    {
      id_cobertura: 0
    }
  ],
  capital: '',
  capitalMin: '',
  capitalMax: '',
  assist: [
    {
      id_servico: 0,
      descricao_cobertura: '',
      valor_capital_informado: '',
      valor_premio: '',
      contrata_dependente: false
    }
  ],
  idProduct: 0,
  descriptionProduct: '',
  hasVariableCapital: false,
  brokerage: '',
  agency: '',
  frequency: '',
  dataPublish: '',
  partner: null,
  registeredPartner: null,
  percentage: '',

  //Step Three

  //Step Four
  selectedFileBannerFour: '',
  selectedFileBannerFourName: '',
  companyTitleFour: '',
  companySubtitleFour: '',
  profileFacebook: '',
  profileTwitter: '',
  profileInstagram: '',
  profileYoutube: '',
  profileLinkedin: ''
};

//Context
export const StepsFormContext = createContext<ContextType | undefined>(
  undefined
);

//Reducer
export enum StepsFormActions {
  setCorretorId,

  //Step One
  setCurrentWebsiteColor,
  setCurrentButtonsColor,
  setWebsiteAddress,
  setWebSiteTitle,
  setSelectedNameLogo,
  setLogoSulamerica,
  setWhatsappNumber,
  setCompanyTitle,
  setCompanySubtitle,
  setSelectedFileBanner,
  setSelectedFileBannerName,
  setSelectedFileLogo,
  setSelectedFileLogoName,
  setEv,

  //Step Two
  setCover,
  setCapital,
  setCapitalMin,
  setCapitalMax,
  setAssist,
  setNameProduct,
  setHasVariableCapital,
  setDescriptionProduct,
  setIdProduct,
  setBrokerage,
  setAgency,
  setFrequency,
  setDataPublish,
  setPartner,
  setRegisteredPartner,
  setPercentage,

  //Step Three

  //StepFour
  setSelectedFileBannerFour,
  setSelectedFileBannerFourName,
  setCompanyTitleFour,
  setCompanySubtitleFour,
  setProfileFacebook,
  setProfileTwitter,
  setProfileInstagram,
  setProfileYoutube,
  setProfileLinkedin
}

const stepsFormReducer = (state: State, action: Action) => {
  switch (action.type) {
    case StepsFormActions.setCorretorId:
      return { ...state, corretorId: action.payload };

    //Step One
    case StepsFormActions.setCurrentWebsiteColor:
      return { ...state, currentWebsiteColor: action.payload };
    case StepsFormActions.setCurrentButtonsColor:
      return { ...state, currentButtonsColor: action.payload };
    case StepsFormActions.setWebsiteAddress:
      return { ...state, websiteAddress: action.payload };
    case StepsFormActions.setWebSiteTitle:
      return { ...state, websiteTitle: action.payload };
    case StepsFormActions.setSelectedNameLogo:
      return { ...state, selectedNameLogo: action.payload };
    case StepsFormActions.setLogoSulamerica:
      return { ...state, logoSulamerica: action.payload };
    case StepsFormActions.setWhatsappNumber:
      return { ...state, whatsappNumber: action.payload };
    case StepsFormActions.setCompanyTitle:
      return { ...state, companyTitle: action.payload };
    case StepsFormActions.setCompanySubtitle:
      return { ...state, companySubtitle: action.payload };
    case StepsFormActions.setSelectedFileBanner:
      return { ...state, selectedFileBanner: action.payload };
    case StepsFormActions.setSelectedFileBannerName:
      return { ...state, selectedFileBannerName: action.payload };
    case StepsFormActions.setSelectedFileLogo:
      return { ...state, selectedFileLogo: action.payload };
    case StepsFormActions.setSelectedFileLogoName:
      return { ...state, selectedFileLogoName: action.payload };
    case StepsFormActions.setEv:
      return { ...state, ev: action.payload };

    //Step Two
    case StepsFormActions.setCover:
      return { ...state, cover: action.payload };
    case StepsFormActions.setCapital:
      return { ...state, capital: action.payload };
    case StepsFormActions.setCapitalMax:
      return { ...state, capitalMax: action.payload };
    case StepsFormActions.setCapitalMin:
      return { ...state, capitalMin: action.payload };
    case StepsFormActions.setAssist:
      return { ...state, assist: action.payload };
    case StepsFormActions.setNameProduct:
      return { ...state, nameProduct: action.payload };
    case StepsFormActions.setHasVariableCapital:
      return { ...state, hasVariableCapital: action.payload };
    case StepsFormActions.setDescriptionProduct:
      return { ...state, descriptionProduct: action.payload };
    case StepsFormActions.setIdProduct:
      return { ...state, idProduct: action.payload };
    case StepsFormActions.setBrokerage:
      return { ...state, brokerage: action.payload };
    case StepsFormActions.setAgency:
      return { ...state, agency: action.payload };
    case StepsFormActions.setFrequency:
      return { ...state, frequency: action.payload };
    case StepsFormActions.setDataPublish:
      return { ...state, dataPublish: action.payload };
    case StepsFormActions.setPartner:
      return { ...state, partner: action.payload };
    case StepsFormActions.setRegisteredPartner:
      return { ...state, registeredPartner: action.payload };
    case StepsFormActions.setPercentage:
      return { ...state, percentage: action.payload };

    //Step Three

    //Step Four
    case StepsFormActions.setSelectedFileBannerFour:
      return { ...state, selectedFileBannerFour: action.payload };
    case StepsFormActions.setSelectedFileBannerFourName:
      return { ...state, selectedFileBannerFourName: action.payload };
    case StepsFormActions.setCompanyTitleFour:
      return { ...state, companyTitleFour: action.payload };
    case StepsFormActions.setCompanySubtitleFour:
      return { ...state, companySubtitleFour: action.payload };
    case StepsFormActions.setProfileFacebook:
      return { ...state, profileFacebook: action.payload };
    case StepsFormActions.setProfileTwitter:
      return { ...state, profileTwitter: action.payload };
    case StepsFormActions.setProfileInstagram:
      return { ...state, profileInstagram: action.payload };
    case StepsFormActions.setProfileYoutube:
      return { ...state, profileYoutube: action.payload };
    case StepsFormActions.setProfileLinkedin:
      return { ...state, profileLinkedin: action.payload };

    default:
      return state;
  }
};

//Provider
export const StepsFormProvider = ({ children }: StepsFormProviderProps) => {
  const [state, setState] = useReducer(stepsFormReducer, initialValues);
  const value = { state, setState };

  return (
    <StepsFormContext.Provider value={value}>
      {children}
    </StepsFormContext.Provider>
  );
};
